<template>
	<div>
		<div v-if="type=='nav1'">
			<van-sticky>
				<div class="navi_back" :style="'background: '+background+';'">
					<div @click="pageBack()" class="navi_back_drop">
						<div class="navi_back_drop_icon">
							<img src="../resource/back.png" alt="" />
						</div>
					</div>
					<div class="navi_back_title">{{title}}</div>
				</div>
			</van-sticky>
		</div>
		<div v-if="type=='nav2'">
			<van-sticky>
				<div class="navi" :style="'background: '+background+';'">
					<div class="navi_back">
						<div @click="pageBack()" class="navi_back_drop">
							<div class="navi_back_drop_icon">
								<img src="../resource/back.png" alt="" />
							</div>
						</div>
						<div class="navi_back_title">{{title}}</div>
					</div>
					<div class="navi_nav2">
						<!-- <div class="navi_nav2_date">
							<div v-for="(item,index) in date_list" :key="index" 
							:class="[{'navi_nav2_date_itemS':index==date_list_index},'navi_nav2_date_item']" 
							@click="selectDateNav2(index)">
								<div>
									<div class="navi_nav2_date_1">{{item.week}}</div>
									<div class="navi_nav2_date_2 font_weight">{{item.date}}</div>
								</div>
							</div>
						</div> -->
						<div class="navi_nav2_type">
							<div class="navi_nav2_type_left">
								<!-- {{cur_city}}
								<img src="../resource/down_666666.png" alt="" /> -->
								<van-dropdown-menu active-color="#FB8027">
									<van-dropdown-item v-model="cur_city2" @change="selectDropdown" :options="cur_city_list" />
								</van-dropdown-menu>
							</div>
							<!-- <div class="navi_nav2_type_right">
								<div @click="selectTtpeTimeNav2(1)" :class="[{'navi_nav2_type_right_itemS':type_time==1},'navi_nav2_type_right_item']">60分钟</div>
								<div @click="selectTtpeTimeNav2(2)" :class="[{'navi_nav2_type_right_itemS':type_time==2},'navi_nav2_type_right_item']">90分钟</div>
							</div> -->
						</div>
					</div>
				</div>
			</van-sticky>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
			},
			type: {
				type: String,
				required: true
			},
			background: {
				type: String,
			},
			// // nav2
			// date_list: {
			// 	type: Array,
			// },
			// date_list_index: {
			// 	type: Number,
			// },
			type_time: {
				type: Number,
			},
			cur_city:{
				type: String,
			},
			cur_city_list:{
				type: Array,
			}
		},
		data() {
			return {
				cur_city2:''
			}
		},
		mounted() {
			this.cur_city2=this.cur_city
		},
		methods: {
			pageBack() {
				this.$router.go(-1)
			},
			
			// nav2
			selectDateNav2(e){
				this.$emit('selectDate',e)
			},
			// selectTtpeTimeNav2(e){
			// 	this.$emit('selectTtpeTime',e)
			// },
			
			selectDropdown(e) {
				// console.log(e);
				this.cur_city2 = e
				// this.getVenusList()
				this.$emit('selectDropdownCity',e)
			},
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.navi{
		width: 100%;
	}
	.navi_back {
		width: 100%;
		background: #fff;
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.navi_back_drop {
			width: fit-content;
			padding: 0 30*@vm_base;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.navi_back_drop_icon {
			width: fit-content;
			height: 80*@vm_base;
			// margin-right: 20*@vm_base;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			img {
				width: 30*@vm_base;
			}
		}

		.navi_back_title {
			width: calc(100% - 180*@vm_base);
			font-size: 32*@vm_base;
			color: #333;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	
	.navi_nav2{
		width: 100%;
		padding: 0 30*@vm_base;
		.navi_nav2_date{
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.navi_nav2_date_item{
				width: 80*@vm_base;
				height: 92*@vm_base;
				border-radius: 16*@vm_base;
				border: 1*@vm_base solid transparent;
				display: flex;
				justify-content: center;
				align-items: center;
				text-align: center;
				color: #666666;
				.navi_nav2_date_1{
					font-size: 20*@vm_base;
				}
				.navi_nav2_date_2{
					font-size: 30*@vm_base;
					margin-top: 6*@vm_base;
				}
			}
			.navi_nav2_date_itemS{
				border: 1*@vm_base solid #F77F28;
				color: #F77F28;
			}
		}
		.navi_nav2_type{
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			// padding: 30*@vm_base 0 20*@vm_base 0;
			.van-dropdown-menu__bar{
				box-shadow: none !important;
			}
			.navi_nav2_type_left{
				font-size: 30*@vm_base;
				color: #333333;
				display: flex;
				justify-content: center;
				align-items: center;
				img{
					width: 22*@vm_base;
					margin-left: 10*@vm_base;
				}
			}
			.navi_nav2_type_right{
				display: flex;
				justify-content: center;
				align-items: center;
				.navi_nav2_type_right_item{
					width: 104*@vm_base;
					height: 38*@vm_base;
					background: #F9F9F9;
					border-radius: 19*@vm_base;
					display: flex;
					justify-content: center;
					align-items: center;
					margin-right: 10*@vm_base;
					font-size: 20*@vm_base;
					color: #999999;
				}
				.navi_nav2_type_right_itemS{
					background: rgba(247, 127, 40, 0.10);
					color: #F77F28;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/navi_back.vue